import {
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Fastfood } from '@material-ui/icons';
import Image from 'material-ui-image';
import React, { FC } from 'react';
import { OnlineOrderingStore, OrderingItem } from 'kiolyn-api';
import { isNullOrUndefined } from 'util';
import CurrencyFormat from '../../../Core/CurrencyFormat/CurrencyFormat';
import { isEmpty } from 'lodash';
import { useOrdering } from '../../../../stores/OrderingStore';

const useStyles = makeStyles(theme => ({
  card: {
    minWidth: 180,
    maxWidth: 320,
    margin: 'auto'
  },
  name: {
    lineHeight: 1.2
  },
  noImage: {
    color: theme.palette.text.disabled,
    fontSize: 100
  },
  cardActions: {
    justifyContent: 'center'
  }
}));

interface ItemCardProps {
  item: OrderingItem;
  unavailableMessage?: string;
  onSelect?: (item: OrderingItem) => void;
  acceptOrdering?: boolean;
}

const ItemCard: FC<ItemCardProps> = ({
  item,
  unavailableMessage,
  onSelect,
  acceptOrdering
}: ItemCardProps) => {
  const classes = useStyles();
  const orderingStore = useOrdering();
  const store = orderingStore.store as OnlineOrderingStore;
  const { name, name2, price, description, imageURL } = item;
  const handleSelect = (item: OrderingItem) => {
    if (
      !isNullOrUndefined(onSelect) &&
      (isNullOrUndefined(item.out_of_stock) ||
        item.out_of_stock === 'In-stock' ||
        item.out_of_stock === '')
    ) {
      onSelect(item);
    }
  };

  return (
    <Card className={classes.card}>
      <CardActionArea
        onClick={() => handleSelect(item)}
        disabled={!acceptOrdering || !isEmpty(unavailableMessage)}
      >
        {!isNullOrUndefined(imageURL) && (
          <Image
            src={imageURL}
            aspectRatio={16 / 9}
            imageStyle={{
              objectFit: 'cover'
            }}
            loading={<Fastfood className={classes.noImage} />}
          />
        )}
      </CardActionArea>
      <CardContent>
        <Typography
          variant="h6"
          color="textPrimary"
          className={classes.name}
          gutterBottom
        >
          {name || ''}
          {store.show_name_2 && !isNullOrUndefined(name2) && ' (' + name2 + ')'}
        </Typography>
        <Typography variant="h6" color="secondary" gutterBottom>
          <CurrencyFormat amount={price} />
        </Typography>
        <Typography variant="body2" color="textSecondary" component="p">
          {description || ''}
        </Typography>
        <Typography variant="body2" color="error" component="p">
          {unavailableMessage || ''}
        </Typography>
        <Typography variant="body2" color="error">
          {(!isNullOrUndefined(item.out_of_stock) &&
            item.out_of_stock !== '' &&
            'Out of stock ' + item.out_of_stock) ||
            ''}
        </Typography>
      </CardContent>
      {acceptOrdering &&
        (isNullOrUndefined(item.out_of_stock) ||
          item.out_of_stock === 'In-stock' ||
          item.out_of_stock === '') &&
        !unavailableMessage && (
          <CardActions className={classes.cardActions}>
            <Button
              onClick={() => handleSelect(item)}
              size="small"
              color="primary"
              aria-label="add to cart"
            >
              Add to cart
            </Button>
          </CardActions>
        )}
    </Card>
  );
};

export default ItemCard;
